import * as React from 'react';
import { ICustomerCodeV2 } from './generated/api/models';

var notInitialisedFn = function notInitialisedFn() {
  throw new Error('SharedAppProvider not initialised');
};

export var SharedAppContextV2 = React.createContext({
  actions: {
    fetchAppContextV2: notInitialisedFn,
    setContractAccountId: notInitialisedFn,
    setPremiseId: notInitialisedFn,
    setSelectedAddressId: notInitialisedFn,
    setSelectedServiceId: notInitialisedFn
  },
  addresses: [],
  businessPartnerId: '',
  customerCode: ICustomerCodeV2.RESI,
  isNative: false,
  originCustomerId: ''
});
var SharedAppContextV2Consumer = SharedAppContextV2.Consumer;
export { SharedAppContextV2Consumer };